import { createContext, useContext, type ReactNode } from 'react'
import { useChat, type UseChatResult } from '../hooks/useChat.js'

/**
 * Shares the active chat state between `AppShell` (sidebar "Nouveau chat" /
 * "Récents" actions) and `ChatPage` (the actual conversation surface). Without
 * this, clicking a recent in the sidebar would mount a separate `useChat`
 * inside the page, leaving the sidebar's state out of sync.
 */
const ChatContext = createContext<UseChatResult | null>(null)

export function ChatProvider({ children }: { children: ReactNode }) {
  const chat = useChat()
  return <ChatContext.Provider value={chat}>{children}</ChatContext.Provider>
}

export function useChatContext(): UseChatResult {
  const ctx = useContext(ChatContext)
  if (!ctx) throw new Error('useChatContext must be used inside ChatProvider')
  return ctx
}
